import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('ManagerList', {
    error: (
        <FormattedMessage
            id='front-app/ManagerList/Notification/Error:title'
            defaultMessage='Manager List Error'
        />
    ),
});

export const managerListNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
